import { Box, Button, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Shared layout styles for Attorney and Expert matters list views. */
export const PageContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.25),
}));

export const HeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(5.5),
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const HeaderTextWrapper = styled(Box)({
  minWidth: 0,
  flex: '1 1 auto',
});

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  lineHeight: 1.2,
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.h1.fontSize,
    lineHeight: 1.35,
  },
}));

export const WelcomeName = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.h1.fontSize,
  },
}));

export const LoadMoreWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
}));

export const LoadMoreButton = styled(Button)(({ theme }) => ({
  minWidth: 140,
  minHeight: 48,
  padding: theme.spacing(1.5, 3),
}));
